<template>
<div class="plain-hero">
  <div class="page-center">
    <div class="row-fluid">
      <div class="span6 left">
        <div>
            <h1>{{texts.intro.heading}}</h1>
            <p>{{texts.intro.about}}</p>
            <p>{{texts.intro.simple}}</p>
          </div>
        </div>
        <div class="span6 right">
            <div>
                <div>
                    <img src="https://cdn2.hubspot.net/hubfs/3826488/Website/Homepage/hero-illustr.svg" role="presentation" alt="Search Designer" width="311">
                </div>
            </div>
        </div>
    </div>
  </div> 
</div>
</template>

<script>
export default {
  name: "SearchDesignerIntroduction"
};
</script>

<style>
#app #introduction-container .plain-hero,
#app #introduction-container .plain-hero p {
  background-color: #313648;
  color: #fff;
}

#app #introduction-container .plain-hero .page-center {
  padding-top: 130px;
  max-width: 1700px;
  margin-bottom: 50px !important;
}

#app #introduction-container .plain-hero .page-center img {
  width: 311px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 15px;
}
</style>




// WEBPACK FOOTER //
// src/components/SearchDesignerIntroduction.vue